import { Modal, Button, InputSelect } from '@wajeez-web/components/ui';
import React, { FC, useState, useEffect } from 'react';
import {
  useContentSelector,
  ContentEntityActions,
} from '@wajeez-web/stores/content';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { useProductSelector, PlansActions } from '@wajeez-web/stores/product';
import { useCommonDispatch } from '@wajeez-web/stores/common';

interface AssignPlansModalProps extends CommonModalProps<number[]> {
  contentEntityId: string;
  loading?: boolean;
}
const AssignPlansModal: React.FC<AssignPlansModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  contentEntityId,
  loading,
}) => {
  const [contentEntityplans, setContentEntityplans] = useState<number[]>([]);
  const { details } = useContentSelector((state) => state.contentEntity);
  const plans = useProductSelector((state) => state.plans.data);
  const dispatch = useCommonDispatch();

  useEffect(() => {
    dispatch(ContentEntityActions.getContentEntityByIdAsync(contentEntityId));
    dispatch(PlansActions.getAllPlansAsync());
  }, [contentEntityId]);

  useEffect(() => {
    if (details) {
      setContentEntityplans(details.plans || []);
    }
  }, [details]);

  return (
    <Modal
      onSubmit={() => onSubmit && onSubmit(contentEntityplans)}
      title={'Assign Plans'}
      open={isOpen}
      onClose={onClose}
      loading={loading}
    >
      <div className="flex space-s-2">
        <div className="w-full">
          {' '}
          <InputSelect
            isMulti={true}
            name={'Plans'}
            value={plans
              .filter((ele) => ele.id && contentEntityplans.includes(ele.id))
              .map((ele) => ({ value: ele.id, label: ele.referenceName }))}
            onChange={(name, value: any) =>
              setContentEntityplans(
                value.map((ele: { value: number }) => ele.value)
              )
            }
            options={plans.map((ele) => ({
              value: ele.id,
              label: ele.referenceName,
            }))}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AssignPlansModal;
